if (!window.ProductFormScrollerInitialized) {
  window.ProductFormScrollerInitialized = true;

  function updateScrollerState(wrapper) {
    const track = wrapper.querySelector('.product-form__input-track');
    if (!track) return;

    const maxScrollLeft = track.scrollWidth - track.clientWidth;
    const isScrollable = maxScrollLeft > 4;
    const canScrollLeft = track.scrollLeft > 4;
    const canScrollRight = track.scrollLeft < maxScrollLeft - 4;

    wrapper.classList.toggle('is-scrollable', isScrollable);
    wrapper.classList.toggle('can-scroll-left', isScrollable && canScrollLeft);
    wrapper.classList.toggle(
      'can-scroll-right',
      isScrollable && canScrollRight,
    );
  }

  function initScroller(wrapper) {
    if (wrapper.dataset.scrollerReady === 'true') return;

    const track = wrapper.querySelector('.product-form__input-track');
    const buttons = wrapper.querySelectorAll(
      '.product-form__input-scroll-button',
    );
    if (!track) return;

    wrapper.dataset.scrollerReady = 'true';
    track.addEventListener('scroll', () => updateScrollerState(wrapper), {
      passive: true,
    });
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const direction = button.classList.contains(
          'product-form__input-scroll-button--left',
        )
          ? -1
          : 1;
        track.scrollBy({ left: direction * 140, behavior: 'smooth' });
      });
    });
    updateScrollerState(wrapper);
  }

  function initAllScrollers(root) {
    (root || document)
      .querySelectorAll('[data-variant-input-scroller]')
      .forEach(initScroller);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () =>
      initAllScrollers(document),
    );
  } else {
    initAllScrollers(document);
  }

  window.addEventListener('resize', () => initAllScrollers(document));
  document.addEventListener('shopify:section:load', (event) =>
    initAllScrollers(event.target),
  );
  document.addEventListener('variant:change', () => initAllScrollers(document));
}
